<template>
  <Badge :variant="BOOKING_STATUS_VARIANT[status]" :size="size">
    {{ $t(`bookingStatus.${status}`) }}
  </Badge>
</template>

<script setup lang="ts">
import Badge from '@/components/Badge.vue';
import type { BadgeVariant } from '@carvia/theme/lib/cva/badge';
import { BookingStatus } from '@carvia/ros-client-types';

defineProps<{
  status: BookingStatus;
  size?: 'sm' | 'md';
}>();

const BOOKING_STATUS_VARIANT: Record<BookingStatus, BadgeVariant> = {
  [BookingStatus.CANCELED]: 'problem',
  [BookingStatus.OPEN]: 'info',
  [BookingStatus.FLOATING]: 'warning',
  [BookingStatus.CONFIRMED]: 'success',
  [BookingStatus.DRAFT]: 'neutral',
  [BookingStatus.HANDED_OVER]: 'walnut',
  [BookingStatus.CAR_RETURNED]: 'obsidian',
  [BookingStatus.FINALIZED]: 'muted',
};
</script>
